module.exports = __webpack_public_path__ + "img/arreglos-de-disfraces.19531277.jpg";